import { xcss, Box } from '@atlaskit/primitives';
import { defineMessages, FormattedMessage } from 'react-intl';
import { useToken } from '../../../Flow/ConsentContextProvider';

const centeredContentStyles = xcss({
  textAlign: 'center',
});

const messages = defineMessages({
  title: {
    id: 'bitbucket.heading',
    defaultMessage: '{clientName} is requesting access to your Atlassian account',
    description: 'Heading for Bitbucket Consent',
  },
});

const Headline = () => {
  const { clientName } = useToken();

  return (
    <Box xcss={centeredContentStyles}>
      <FormattedMessage {...messages.title} values={{ clientName }} tagName="h1" />
    </Box>
  );
};

export default Headline;
